const voipExtension = [
	{
		path: "/extensionManagement",
		name: "分机管理",
        component: () => import(/* webpackChunkName: "dialer" */ "../views/dialer/extensionManagement.vue"),
        meta: {id: 41, hidden: true, name: "menu.ExtensionManagement"}
	},
	{
		path: "/assignedPhoneHistory/:item",
		name: "分配历史",
		hidden: true,
        component: () => import(/* webpackChunkName: "dialer" */ "../views/dialer/assignedPhoneHistory.vue"),
        meta: {id: 200, hidden: true, name: "menu.UserManagement"}
	},
	{
		path: "/voipManagement",
		name: "voip管理",
		hidden: true,
		component: () => import(/* webpackChunkName: "dialer" */ "../views/dialer/voipManagement.vue"),
		meta: {id: 227, hidden: true, name: "menu.VoipManagement"}
	}
]
export default voipExtension;
